const mutations = {
  GET_DATE(state) {
    return state.date;
  },

  SET_DATE(state, date) {
    state.date = date;
  },

  GET_TOKEN(state) {
    return state.token;
  },

  SET_TOKEN(state, token) {
    state.token = token;
  },

  GET_NOTA(state) {
    return state.nota;
  },

  SET_NOTA(state, nota) {
    state.nota = nota;
  },

  GET_PRODUTOS(state) {
    return state.produtos;
  },

  SET_PRODUTOS(state, produtos) {
    state.produtos = produtos;
  },

  GET_BENEFICIO(state) {
    return state.beneficio;
  },

  SET_BENEFICIO(state, beneficio) {
    state.beneficio = beneficio;
  },
};

export default mutations;
